import { useState, useCallback } from "react";
import { toast } from "sonner";
import axios from "./axios";

// Global state to persist across component remounts
let globalApiState = {
  hasBeenCalled: false,
  rewards: null,
  error: false,
};

export const useRecallAndMatchGame = () => {
  const [loading, setLoading] = useState(false);
  const [rewards, setRewards] = useState(globalApiState.rewards);
  const [error, setError] = useState(globalApiState.error);

  const submitGameResult = useCallback(
    async (difficulty, percentageOfCompletion, totalImages, id, gameId) => {
      // Prevent duplicate calls using global state
      if (globalApiState.hasBeenCalled) {
        return globalApiState.rewards;
      }

      globalApiState.hasBeenCalled = true;
      setLoading(true);
      setError(false);

      try {
        const response = await axios.post(
          `/audiences/recall-and-match/play/${id}`,
          {
            game_id: gameId,
            difficulty: difficulty,
            percentage_of_completion: percentageOfCompletion,
            total_images: totalImages,
          },
          {
            headers: {
              Authorization:
                "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5ZjhkZjA3YS04YjM5LTQwNWUtODg5Zi0yOTE0Y2NhNDI2ZDAiLCJqdGkiOiIzMWIwOTJiZmEwZDM2NmIzNTY5YTI0NmE2NWIzMzZjZTFmOTcxNzEwNWU4NDVjN2Y4OWQxNTg3N2ExYjcxODEyYWVlNDUxYTM2ZTNlMGQ1YiIsImlhdCI6MTc1NDMyODY3My44OTc5MTksIm5iZiI6MTc1NDMyODY3My44OTc5MjEsImV4cCI6MTc4NTg2NDY3My41OTExMTcsInN1YiI6IjlmOGUyNWI5LWRhMjUtNDg3MC04MWY5LTJmYzdkNDRkZTc3MCIsInNjb3BlcyI6W119.UTD4hFZndBg_eIh9VDwmICRrp3G3RK2Es6sZonSsa0kQFDCzZhq7oDA9tB34PmMg3cslTtxRALjyaeDsfb6sbRFUe4EEZzL2s2BK-01aLAvMJTBAkYMS-MT_jUlzAiI83w1ZjhyY3umCQJB03OFTR6cj_9_9PJyJ5hpMdvSWKE0BZ_02mc0ERK5DnhmNRcjmeBIDsiGLpkmLesNoMXQY8BjKO7w0_58MZ4nz3SvxRWpTy1460aSXuZgyEMr-ID57WjQUGq5xixoEUIhlO_wbZtYD44IcudHz8bICV1YfP8xqAGB8zpTLPaePqL739DIEMvEkNDl9dwveAr_jKXCRGlfI_7QlO_W2y5u5E0Jio95dxYAGKe89pIBK3tscPKkPTZARv8FJKezkGeh8P5RP1LkDWp9Tb8ntBSh338Lkoznwjxlb0UL4JTUhGVO8Q7eyCwfK1a6_1bqIFDIe7CF8YEfISAGZJEPIX0tTzJrjdg5VnS6PP93js33jWX3l5LRRS8ESNr97TxfjYLTMZhxZAHLfUQ_UZy_gV60bIqnsUt_kqJO883QJtIRCpTUDowVWaP0EvZFK5tTNgLxIcgCeHR20rRp7q7RCUbafBehEAXISu_trcRp3feTbUplRj9Y0zUa-_NQf0-OOBwgvUFL2NCQm_9PiLYJVJMUhxOYHJJk",
            },
          },
        );

        if (response.status === 200) {
          // Update global state
          globalApiState.rewards = response.data;
          globalApiState.error = false;

          setRewards(response.data);
          setLoading(false);
          return response.data;
        } else {
          // Update global state
          globalApiState.error = true;
          globalApiState.hasBeenCalled = false; // Allow retry on error

          setError(true);
          setLoading(false);
          toast.error("Failed to submit game result");
        }
      } catch (err) {
        console.error("💥 API call exception:", err);

        // Update global state
        globalApiState.error = true;
        globalApiState.hasBeenCalled = false; // Allow retry on error

        setError(true);
        setLoading(false);
        toast.error("Failed to submit game result");
      }
    },
    [],
  );

  const resetState = useCallback(() => {
    // Reset global state
    globalApiState.hasBeenCalled = false;
    globalApiState.rewards = null;
    globalApiState.error = false;

    // Reset local state
    setRewards(null);
    setError(false);
    setLoading(false);
  }, []);

  return {
    submitGameResult,
    loading,
    rewards,
    error,
    resetState,
  };
};
